import {
  RackCellSchema,
  WarehouseCellSchema,
} from "@redotech/redo-fulfillment-wms-common/schema/warehouse-cell";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const clearRemovedWarehouseBinInventory = {
  name: "clearRemovedWarehouseBinInventory" as const,
  input: z.object({
    crdbLocationId: locationIdFormat.schema,
    racks: z.record(z.string(), RackCellSchema),
    grid: z.array(z.array(WarehouseCellSchema)).optional(),
  }),
  output: z.object({ clearedBins: z.number(), clearedUnits: z.number() }),
};
